import { sessionPrefix } from "./helpers";

export const hotseatPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/hotseat/requests`;
export const hotseatQuestionsPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/hotseat/questions`;
